import { Heart } from 'lucide-react';
import { useFavorites } from '@/contexts/FavoritesContext';
import { toast } from 'sonner';

const FavoriteButton = ({ property, size = "default", className = "" }) => {
  const { isFavorite, toggleFavorite } = useFavorites();
  const isActive = isFavorite(property.id);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleFavorite(property);
    
    if (!isActive) {
      toast.success('Añadido a favoritos');
    } else {
      toast.info('Eliminado de favoritos');
    }
  };

  const sizeClasses = {
    small: "w-8 h-8",
    default: "w-10 h-10",
    large: "w-12 h-12"
  };

  const iconSizes = {
    small: 16,
    default: 20,
    large: 24
  };

  return (
    <button
      onClick={handleClick}
      className={`
        ${sizeClasses[size]} 
        flex items-center justify-center rounded-full 
        transition-all duration-300 
        ${isActive 
          ? 'bg-red-500 text-white' 
          : 'bg-black/60 text-white hover:bg-black/80'
        }
        ${className}
      `}
      title={isActive ? 'Quitar de favoritos' : 'Añadir a favoritos'}
      data-testid={`favorite-btn-${property.id}`}
    >
      <Heart 
        size={iconSizes[size]} 
        className={isActive ? 'fill-current' : ''} 
      />
    </button>
  );
};

export default FavoriteButton;
